/**
 * Store loadAnimation from Lottie.
 */
let LOTTIE_ANIMATION_LOADER;
/**
 * Store all intances of Element.
 */
const INSTANCES = new Set();
/**
 * Store supported triggers.
 */
const TRIGGERS = new Map();
/**
 * Store icons data in memory.
 */
const ICONS = new Map();
/**
 * List of promises for pending icons.
 */
const LOADING = new Map();
/**
 * Register new icon. Notify all instances about it.
 * @param name
 * @param iconData
 */
export function registerIcon(name, iconData) {
    ICONS.set(name, iconData);
    for (const instance of INSTANCES) {
        instance.notify(name, 'icon');
    }
}
/**
 * Register new trigger. Notify all instances about it.
 * @param name
 * @param triggerClass
 */
export function registerTrigger(name, triggerClass) {
    TRIGGERS.set(name, triggerClass);
    for (const instance of INSTANCES) {
        instance.notify(name, 'trigger');
    }
}
/**
 * Register lottie "loadAnimation" method.
 * @param animationLoader
 */
export function registerAnimationLoader(animationLoader) {
    LOTTIE_ANIMATION_LOADER = animationLoader;
}
/**
 * Store element instance.
 * @param element
 */
export function connectInstance(element) {
    INSTANCES.add(element);
}
/**
 * Remove element instance.
 * @param element
 */
export function disconnectInstance(element) {
    INSTANCES.delete(element);
}
/**
 * Get stored icon.
 * @param name
 */
export function getIcon(name) {
    return ICONS.get(name);
}
/**
 * Get stored trigger.
 * @param name
 */
export function getTrigger(name) {
    return TRIGGERS.get(name);
}
/**
 * Fetch icon data from server.
 * @param url
 */
export async function loadIconData(url) {
    const response = await fetch(url);
    return await response.json();
}
/**
 * Load icon from url. This method tries to load single icon only once.
 * @param url
 */
export async function loadIcon(url) {
    if (ICONS.has(url)) {
        return;
    }
    const current = LOADING.get(url);
    if (current) {
        await current;
        return;
    }
    if (current === undefined) {
        const promise = loadIconData(url);
        LOADING.set(url, promise);
        const data = await promise;
        LOADING.delete(url);
        ICONS.set(url, data);
    }
}
/**
 * Execute animation loading with provided "loadAnimation".
 * @param params
 */
export function loadLottieAnimation(params) {
    if (!LOTTIE_ANIMATION_LOADER) {
        throw new Error('Unregistered Lottie.');
    }
    return LOTTIE_ANIMATION_LOADER(params);
}
